import { render } from "./PaymentCreatePage.vue?vue&type=template&id=72d4d9a4"
import script from "./PaymentCreatePage.vue?vue&type=script&lang=js"
export * from "./PaymentCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__